/* 
-----------------------------------------------------------------------------
| PERSONAL DETAILS PAGE
-----------------------------------------------------------------------------
- description: no booking data logic goes here, just metrics, redirects etc.
*/
import { FC, useEffect, useRef, useState } from "react";
import { useApp } from "../context/useApp";
import { DEFAULT_DIALOG_HANDLE, LANG, ROUTES, rumba } from "../utils/symbols";
import { PersonalDetailsForm } from "../components/personal-details/PersonalDetailsForm";
import { Aside } from "../components/personal-details/Aside";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { loadEnvValue } from "../utils/helpers";
import { _ } from "../utils/helpers";
import { useDefaultDialogs } from "../hooks/useDefaultDialogs";
import { AsideInsideElements } from "../components/personal-details/AsideInsideElements";
import { StepControls } from "../components/table-layout/aside/StepControls";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(loadEnvValue('REACT_APP_STRIPE_LOAD'), {locale: LANG} as any);


export const PersonalDetailsPage: FC = () => {

    const {
        state: { booking, dialogHandles, forcedRenders, shifts },
        actions: { navigate, genericError }
    } = useApp()

    const [options, setOptions] = useState<{clientSecret: string} | null>(null)
    const [stripeComplete, setStripeComplete] = useState<boolean>(false)

    const defaultDialogs = useDefaultDialogs()
    const firstTime = useRef(true)
    const dialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    const getClientSecret = async () => {

        firstTime.current = false

        dialogHandle.openDialog({ dialog: 'loading', className: 'w-100 df aic jcc loading' })
        const bookingSummary = booking.getBookingSummary()
        const amount = Math.floor(bookingSummary.total * 100)

        const response = await rumba.getClientSecret(amount, booking)
        if (response.result !== 'ok') {
            defaultDialogs.show('no-tables')
            return
        }
        if (response.result === 'ok' && response.amount  !== amount) {
            genericError(() => {
                navigate(ROUTES.TABLE_LAYOUT)
                booking.setBookingStep('products').render()
            })
			return
		}

        setOptions({clientSecret: response.intent})
        dialogHandle.closeDialog()
    }



    useEffect(() => {

        if(dialogHandles.size === 0) return
        
        if (booking.step === 'date') {navigate(ROUTES.DATE); return}
        if (booking.step === 'shift') {navigate(ROUTES.TABLE_LAYOUT); return}
        if (booking.step === 'tickets') {navigate(ROUTES.TABLE_LAYOUT); return}
        if (booking.step === 'products') {navigate(ROUTES.TABLE_LAYOUT); return}
        
        return () => setOptions(null)

    }, [dialogHandles])

    useEffect(() => {

        const shift = shifts.find((shift) => shift.id === booking.shiftId)
        if (!shift) return 

        const errors = booking.validatePersonalDetail({ shift: shift })
        if (errors.length === 0 && firstTime.current) getClientSecret()

    }, [forcedRenders, shifts])

    return options ? (
        <Elements stripe={stripePromise} options={options}>
            <main 
                id="personal-details-page" 
                className="page-container df aic jcc fd-c layout-b w-100 test-ab-page" 
                role="application"
                aria-label={_('3zo_tocon_i')}
            >
                <StepControls />
                <div className="h-100 w-100 df aifs jcsb px-10 zones layout-b-content">
                    <PersonalDetailsForm setStripeComplete={setStripeComplete} insideElements/>
                    <AsideInsideElements stripeComplete={stripeComplete} clientSecret={options?.clientSecret} />
                </div>
            </main>
        </Elements> 
    ) 
    : 
    <main 
        id="personal-details-page" 
        className="page-container df aic jcc fd-c layout-b w-100 test-ab-page" 
        role="application"
        aria-label={_('3zo_tocon_i')}
    >
        <StepControls />
        <div className="h-100 w-100 df aifs jcsb px-10 zones layout-b-content">
            <PersonalDetailsForm setStripeComplete={setStripeComplete} />
            <Aside stripeComplete={stripeComplete} />
        </div>
    </main>
}
